module.exports = __webpack_public_path__ + "static/img/img-logo-bank-syariah-artha.e2673f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-logo-bank-syariah-artha.png
// module id = Z+Sb
// module chunks = 36